import axios from './axios';

// Axios setup
window.axios = axios;
